import { URL } from 'Core/Common/Url';
import { P } from 'Core/Common/Promise';
import {RelationsToCopyEntityModel} from "Core/GeneralProperties/Managers/RelationsToCopyProperty/Models/EntityModel";
import { Request, IRequestOptions } from 'Core/Common/Request';

export class RelationsToCopyPropertyStore {
    static GetRelationsToCopyEntities(entityId: number): P.Promise<RelationsToCopyEntityModel[]> {
        var deferredResult = P.defer<any>();
        
        let params = {
            EntityId: entityId
        };

        var requestParams: IRequestOptions = {
            proxy: {
                url: URL.FORM_DESIGNER.GET_RELATIONS_TO_COPY_ENTITIES,
                type: 'GET'
            },
            params: params
        };

        Request.Send(requestParams).then(data => {
            deferredResult.resolve(data);
        });

        return deferredResult.promise();
    }
}